/**
 * Created by andrey on 08.08.2025
 */

cc.Show = function () {
    cc.ActionInstant.prototype.constructor.call(this);
};

cc.Show.prototype = Object.assign(Object.create(cc.ActionInstant.prototype), {
    constructor: cc.Show,

    update: function () {
        this.target.visible = true;
    }
});

cc.show = () => new cc.Show();
